import { Navigate } from "react-router-dom"
import { useGeneralContext } from "../../../Contexts/GeneralContext/GeneralProvider"
import { ModalTypes } from "../../../Interfaces/ContextInterfaces/GeneralContext"

// Replaces the current history entry, so the back button does not return to a screen that
// had nothing to show.
function RedirectToSection({ section }: { section: ModalTypes['type'] }) {

	const { getSectionPath } = useGeneralContext()
	const path = getSectionPath(section)

	return path ? <Navigate to={path} replace /> : null
}

export default RedirectToSection
